var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50025 10.0002C1.24425 10.0002 0.98825 9.90225 0.79325 9.70725C0.40225 9.31625 0.40225 8.68425 0.79325 8.29325L4.09825 4.98825L0.91825 1.69525C0.53525 1.29725 0.54625 0.664249 0.94325 0.281249C1.34125 -0.101751 1.97425 -0.090751 2.35725 0.305249L6.21925 4.30525C6.59825 4.69825 6.59325 5.32125 6.20725 5.70725L2.20725 9.70725C2.01225 9.90225 1.75625 10.0002 1.50025 10.0002Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevRight);
export default __webpack_public_path__ + "static/media/chev-right.374485e19091a5701658f909497fb21c.svg";
export { ForwardRef as ReactComponent };